import React, { useState } from 'react';
import { Form } from '@ant-design/compatible';
import { useQueryClient } from '@tanstack/react-query';

import GeneratePointValidSuccessModalView from './GeneratePointValidSuccessModalView';
import { useGeneratePoint } from './hooks';
import { USER_ACTIONS_NAME } from '../../../../../../constants/service/app/accountUserConstants';
import { accountUserActions } from '../../../../../../store/modules/account/user';
import { accountUserDetailKey } from '../../common/queryKeys';

const GeneratePointValidSuccessModalContainer = (props) => {
  const { closeModal, form, validResult } = props;
  const queryClient = useQueryClient();
  const [memo, setMemo] = useState();

  const { generatePoint } = useGeneratePoint();
  const handleSubmit = async () => {
    const { userPointList, impossibleCnt } = validResult;
    await generatePoint({
      userPointList,
      impossibleCnt,
      memo,
      targetAction: {
        name: USER_ACTIONS_NAME,
        ...accountUserActions,
      },
    });

    //유저상세 -> 포인트 정보 페이지의 데이터를 재요청
    queryClient.invalidateQueries({
      queryKey: [...accountUserDetailKey, 'pointDetail'],
    });

    closeModal();
  };

  return (
    <GeneratePointValidSuccessModalView
      closeModal={closeModal}
      form={form}
      memo={memo}
      setMemo={setMemo}
      onSubmit={handleSubmit}
      validResult={validResult}
    />
  );
};

export default Form.create()(GeneratePointValidSuccessModalContainer);
